import { LayoutItem } from "@/types/breeze/Dashboard";
import { SkeletonTileLayout } from "@/components/ui/Skeleton";

const KEY = "anythink:dashboard-layout-cache";

type CacheShape = Record<string, SkeletonTileLayout[]>;

function read(): CacheShape {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as CacheShape) : {};
  } catch {
    return {};
  }
}

function write(cache: CacheShape) {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(cache));
  } catch {
    // sessionStorage quota or unavailable — skeleton just falls back to the generic shape.
  }
}

// "home" is the sentinel for the user's default dashboard (no routeDashboardId).
function keyFor(dashboardId: number | "home"): string {
  return String(dashboardId);
}

export function getCachedSkeletonLayout(dashboardId: number | "home"): SkeletonTileLayout[] | undefined {
  return read()[keyFor(dashboardId)];
}

export function saveSkeletonLayout(dashboardId: number | "home", layoutJson: string | null) {
  if (!layoutJson) return;
  let parsed: LayoutItem[];
  try {
    const decoded = JSON.parse(layoutJson);
    if (!Array.isArray(decoded)) return;
    parsed = decoded as LayoutItem[];
  } catch {
    return;
  }
  const tiles: SkeletonTileLayout[] = parsed.map((l) => ({ x: l.x, y: l.y, w: l.w, h: l.h }));
  const cache = read();
  cache[keyFor(dashboardId)] = tiles;
  write(cache);
}
